import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.viewPerspective === 'brand' && _ctx.action === 'brand-respond')
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 0,
          label: "Respond to Request",
          class: "p-button-link",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('respond', { item: _ctx.item, request: _ctx.request, offer: _ctx.lastOffer })), ["stop"]))
        }))
      : _createCommentVNode("", true),
    (_ctx.viewPerspective === 'creator' && _ctx.action === 'creator-respond')
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 1,
          label: "Respond to Request",
          class: "p-button-link",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('respond', { item: _ctx.item, request: _ctx.request, offer: _ctx.lastOffer })), ["stop"]))
        }))
      : _createCommentVNode("", true)
  ]))
}